import { DATA_ATTR_THEME_MODE } from './consts';
import type { Direction, ThemeMode } from './types';

export const getDocumentAttributes = (params: {
  /**
   * Direction of the text, either `ltr` (left-to-right) or `rtl` (right-to-left).
   *
   * Returned as the `dir` attribute for the `html` element.
   */
  direction: Direction;
  /**
   * Language code as defined in [RFC 5646: Tags for Identifying Languages (also known as BCP
   * 47)](https://datatracker.ietf.org/doc/html/rfc5646).
   *
   * Returned as the `lang` attribute for the `html` element.
   */
  language: string;
  /**
   * Alchemy theme mode to set on the `<html>` element.
   *
   * Returned as the `data-al-theme` attribute for the `html` element.
   */
  themeMode: ThemeMode;
}) => ({
  [DATA_ATTR_THEME_MODE]: params.themeMode,
  lang: params.language,
  dir: params.direction,
});
